export default __webpack_public_path__ + "static/hammarby-stpolten-bg-c885d57f0f42499bb5e153132eda8c2f.jpg";